import styles from "./Button.module.css";

interface ButtonProps {
    customClassName?: string
    buttonText: string
    handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const Button: React.FC<ButtonProps> = ({ customClassName = "", buttonText, handleClick }) => {

    return (
        <button 
            className={`${styles[customClassName]}`}
            onClick={handleClick}
        >
            {buttonText}
        </button>
    );

}


export default Button;